/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-case-declarations */
/* eslint-disable camelcase */
// callback:快手｜gdt_vid:腾讯｜clue_id:字节
// 字节回传接口:reportByteDance
import { isBrowser, getWindow } from '@cap/ssr-common-utils';
import { lx } from '../../utils/lx';
import { logger } from '../../utils/logger';
import { getSearch } from '../../utils/urlHelper';
import { uploadAdvertise } from './api';

export enum AD_USER_ACTION {
  PAGE_VIEW = 1,
  SUBMIT_APPLICATION = 2,
}

enum AD_PLATFORM {
  kuaishou = 'kuaishou',
  tenant = 'tenant',
  bytedance = 'bytedance',
  baidu = 'baidu',
}

interface ReportParams {
  action: AD_USER_ACTION;
  id?: string;
  url: string;
  queryKey?: string;
  queryValue?: string;
}

const reportFunction = (label: AD_PLATFORM) => async (params: ReportParams) => {
  if (!isBrowser) {
    return;
  }
  const { id, url, action, queryKey } = params;
  try {
    lx.moduleView({
      bid: 'b_donation_application_callback_mv',
      options: {
        cid: 'c_donation_service_detail',
      },
      custom: {
        id, // 产品服务id
        url, // 上报url
        action, // 用户行为  1：页面曝光｜2：报名点击；
        ad_panel: queryKey,
        adPlatform: label,
      },
    });
    switch (label) {
      default:
        await uploadAdvertise({
          userAction: action,
          logIdUrl: url,
        });
        break;
    }
  } catch (error) {
    logger.log(error);
  }
};

interface AdPlatformDto {
  key: number;
  queryKey: string;
  label: string;
  panelAction: AD_USER_ACTION[];
  callback: (data: ReportParams) => Promise<void>;
  queryValue?: any;
}

/**
 * 广告平台列表
 */
const ENU_ADVERTISER_INFO: Array<AdPlatformDto> = [
  /**
   * @see https://dev2.baidu.com/content?sceneType=0&pageId=104789&nodeId=1555&subhead=
   */
  {
    key: 2,
    queryKey: 'bd_vid',
    label: '百度',
    panelAction: [AD_USER_ACTION.PAGE_VIEW, AD_USER_ACTION.SUBMIT_APPLICATION],
    callback: reportFunction(AD_PLATFORM.baidu),
  },
  /**
   * @see https://open.oceanengine.com/labels/9/docs/1754718886606851
   */
  {
    key: 3,
    queryKey: 'clickid',
    label: '字节',
    panelAction: [AD_USER_ACTION.PAGE_VIEW, AD_USER_ACTION.SUBMIT_APPLICATION],
    callback: reportFunction(AD_PLATFORM.bytedance),
  },
  /**
   * @see https://docs.qingque.cn/d/home/eZQDnexll3-ebbtlX3xEDvBN3?identityId=1oECYDND3qd#section=h.9cnktvm7ek5t
   */
  {
    key: 4,
    queryKey: 'callback',
    label: '快手',
    panelAction: [AD_USER_ACTION.PAGE_VIEW, AD_USER_ACTION.SUBMIT_APPLICATION], // 用户行为：1：页面曝光；2：报名点击；
    callback: reportFunction(AD_PLATFORM.kuaishou),
  },
  /**
   * @see https://datanexus.qq.com/doc/develop/guider/interface/conversion/trackingcgi_api_web
   */
  {
    key: 5,
    queryKey: 'qz_gdt',
    label: '腾讯',
    panelAction: [AD_USER_ACTION.PAGE_VIEW, AD_USER_ACTION.SUBMIT_APPLICATION],
    callback: reportFunction(AD_PLATFORM.tenant),
  },
];

/**
 * 获取目标页面的广告监测平台
 * @returns
 */
function useADTargetPage() {
  const queryParams = getSearch();
  logger.log('queryParams', queryParams);
  const adSource = ENU_ADVERTISER_INFO.map((item) => {
    return {
      ...item,
      queryValue: queryParams[item.queryKey],
    };
  }).filter((item) => {
    return !!item.queryValue;
  });
  return adSource;
}

function useADRoute(adSource: Array<AdPlatformDto>, params: ReportParams) {
  if (adSource?.length <= 0) return () => {};
  return () => {
    const { action } = params;
    adSource.map((item) => {
      const { panelAction, callback, queryKey, queryValue } = item;
      if (panelAction.some((act) => action === act)) {
        return callback({ queryKey, queryValue, ...params });
      }
      return null;
    });
  };
}

export async function applicationCallback(params: {
  action: AD_USER_ACTION;
  id?: string;
  url?: string;
}) {
  const window = getWindow();
  const adSource = useADTargetPage();
  const callback = useADRoute(adSource, {
    url: window.location.href,
    ...params,
  });
  callback();
}
